// Time and number formatting for labels, the readout and the summary paragraph.

const DATE_TIME = { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23" } as const;
const LONG = { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit", hourCycle: "h23" } as const;
const utcFmt = new Intl.DateTimeFormat("en-US", { timeZone: "UTC", ...DATE_TIME });
const etFmt = new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", ...DATE_TIME });
const dayFmt = new Intl.DateTimeFormat("en-US", { timeZone: "UTC", weekday: "short", day: "numeric", month: "short" });
const longFmt = new Intl.DateTimeFormat("en-US", { timeZone: "UTC", ...LONG });
const longEtFmt = new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", ...LONG });

interface Parts { weekday: string; day: string; month: string; hour: string; minute: string }
function parts(fmt: Intl.DateTimeFormat, ms: number): Parts {
  const p: Parts = { weekday: "", day: "", month: "", hour: "", minute: "" };
  for (const x of fmt.formatToParts(new Date(ms))) if (x.type in p) p[x.type as keyof Parts] = x.value;
  return p;
}

export const fmtUtc = (ms: number): string => { const p = parts(utcFmt, ms); return `${p.weekday} ${p.day} ${p.month} ${p.hour}:${p.minute} UTC`; };
export const fmtEt = (ms: number): string => { const p = parts(etFmt, ms); return `${p.weekday} ${p.day} ${p.month} ${p.hour}:${p.minute} ET`; };
export const fmtDay = (ms: number): string => { const p = parts(dayFmt, ms); return `${p.weekday} ${p.day} ${p.month}`; };
/** "21 Sep": the day label when the axis is too narrow for the weekday. */
export const fmtDayShort = (ms: number): string => { const p = parts(dayFmt, ms); return `${p.day} ${p.month}`; };
export const fmtLong = (ms: number): string => { const p = parts(longFmt, ms); return `${p.weekday} ${p.day} ${p.month} ${p.hour}:${p.minute} UTC`; };
export const fmtLongEt = (ms: number): string => { const p = parts(longEtFmt, ms); return `${p.weekday} ${p.day} ${p.month} ${p.hour}:${p.minute} ET`; };
export const fmtClock = (ms: number): string => new Date(ms).toISOString().slice(11, 19) + " UTC";
export const fmtIso = (ms: number): string => new Date(ms).toISOString().replace("T", " ").slice(0, 19) + " UTC";
/** Weekday abbreviation in New York time, for the freeze labels. */
export const wdEt = (ms: number): string => parts(etFmt, ms).weekday;

export function dur(ms: number): string {
  const s = Math.max(0, Math.round(ms / 1000));
  if (s < 90) return `${s} s`;
  const m = Math.round(s / 60);
  if (m < 90) return `${m} min`;
  const h = Math.floor(m / 60), d = Math.floor(h / 24);
  if (d >= 1) return `${d}d ${h % 24}h`;
  return `${h}h ${m % 60}m`;
}
export const fmtPrice = (v: number | null | undefined): string =>
  v == null ? "n/a" : v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: v < 10 ? 4 : 2 });
export const fmtPct = (v: number | null | undefined): string => (v == null ? "n/a" : `${v >= 0 ? "+" : ""}${v.toFixed(2)} %`);
